import React from 'react';
import { Avatar, AvatarGroup, Box, Link, Tooltip, Typography } from '@mui/material';

// Up to three products that carry an unmapped label: thumbnails to hover (bigger photo, name,
// retailer) and click (the product page), so the admin can see what the AI's label looks like
// before mapping it (Daniel, 2026-10-22). products: [{ id, name, image_url, url, retailer }].
export default function SampleProducts({ products, size = 36 }) {
  if (!products || products.length === 0) {
    return <Typography variant="body2" color="text.secondary">-</Typography>;
  }
  return (
    <AvatarGroup max={4} spacing="small" sx={{ justifyContent: 'flex-end', '& .MuiAvatar-root': { width: size, height: size, border: '1px solid #ddd' } }}>
      {products.map(p => (
        <Tooltip
          key={p.id}
          placement="right"
          componentsProps={{ tooltip: { sx: { bgcolor: 'background.paper', color: 'text.primary', boxShadow: 3, p: 1, maxWidth: 280 } } }}
          title={
            <Box>
              <img src={p.image_url} alt={p.name || ''} style={{ width: 240, height: 240, objectFit: 'contain', display: 'block' }} loading="lazy" />
              <Typography variant="body2" sx={{ mt: 0.5, fontWeight: 500 }}>{p.name || '(no name)'}</Typography>
              <Typography variant="caption" color="text.secondary">{p.retailer}{p.url ? ' · click to open' : ''}</Typography>
            </Box>
          }
        >
          <Link href={p.url || undefined} target="_blank" rel="noopener noreferrer" underline="none" sx={{ cursor: p.url ? 'pointer' : 'default' }}>
            <Avatar src={p.image_url} alt={p.name || ''} variant="rounded" imgProps={{ loading: 'lazy' }} />
          </Link>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
}
